export default __webpack_public_path__ + "static/media/actor-face-name.0762cba1.png";